import AddressLink from '@repo/ui/address-link'
import { useQuery } from '@tanstack/react-query'

import { getCenter } from '../../../../api/centers/get-center'
import { getTeachingHalls } from '../../../../api/ols/teaching-halls/get-teaching-halls'
import { useDataProps } from '../../../../lib/hooks/use-data-props'
import { useNativeCountryName } from '../../../../lib/hooks/use-native-country-name'
import { AccomodationEnum } from '../../../../lib/types/enums/accomodation-type/accomodation-type'
import { Center } from '../../../../lib/types/models/center/center'
import { CenterProperties } from '../../../../lib/types/models/center/properties.center'
import { DataProps } from '../../../../lib/types/utils'
import LabelWithText from '../../ols/label-with-text'

export function CenterAddressCoursesLabel(props: DataProps<Center>) {
  const nativeCountryName = useNativeCountryName()
  const { data: center } = useDataProps(props, (id) => getCenter(id, 'FULL'))

  const { data: teachingHalls } = useQuery({
    queryKey: ['centers', center?.id, center?.olId],
    queryFn: () => {
      if (center?.olId) return getTeachingHalls(center.olId, { filter: { centerId: center.id } })
    },
    enabled: !!center?.olId && center.accomodation === AccomodationEnum.HOST_FAMILY
  })

  const centerTeachingAddress = CenterProperties.getCenterTeachingCompleteAddress(
    center?.olJourneyPlace
  )

  if (!center) return null

  const renderCoursesAddress = () => {
    if (center.accomodation === AccomodationEnum.HOST_FAMILY) {
      if (!teachingHalls?.data.length) return '-'

      return teachingHalls.data.map((teachingHall) => (
        <AddressLink
          key={teachingHall.id}
          address1={teachingHall.address1}
          address2={teachingHall.address2}
          zipCode={teachingHall.postalCode}
          city={teachingHall.city}
          country={nativeCountryName(teachingHall.country)}
        />
      ))
    }

    if (!centerTeachingAddress?.address1) return '-'

    return (
      <AddressLink
        address1={centerTeachingAddress.address1}
        address2={centerTeachingAddress.address2}
        zipCode={centerTeachingAddress.zipCode}
        city={centerTeachingAddress.city}
        country={nativeCountryName(centerTeachingAddress.country)}
      />
    )
  }

  return <LabelWithText label="Adresse des cours" data={renderCoursesAddress()} />
}
